import React from 'react';
import {Link} from 'react-router-dom';
// imgs
import pic1 from '../imgs/1.jpg';
import banner_bg from '../imgs/banner-bg.jpg';
import banner_bg_2 from '../imgs/banner-bg-2.jpg';

// seed
import {properties} from '../seed/data';

class Search extends React.Component {
  renderProperties () {
    return properties.map((p, i) => (
      <div className="col-6 col-sm-6 col-md-4 col-lg-3" key={i}>
              <Link to={`/property/${i}`} className="card-link">
                <div className="property-listing-item">
                  <div className="property-listing-item-img">
                    <img src={p.img}/>
                  </div>
                  <div className="property-listing-item-info">
                    <div className="property-listing-item-info-major">{p.address}</div>
                    <div className="property-listing-item-info-minor flex-space-between">
                      <span>{p.room_count} Rm avail.</span>
                      <span>${p.price}/Rm</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
    ))
  }
  render() {
    let params = new URLSearchParams(this.props.history.location.search);
    let q = params.get("q");
    return (
      <div className="container frame">
        
        {/*PROPERTY LISTING*/}
        <div className="row">
        <h4 className="section-title"><small>Search results for</small> {q}</h4>
        </div>
        <div className="row">
            {this.renderProperties()}
          </div>
      </div>
      )
  }
}

export default Search;